<template>
  <div class="whole" flexContainer :style="{ height: pub_height + 'px' }">
    <div class="button" flexContainer>
      <div flex-1></div>
      <!-- <ddbutton class="add_but" @click="update_publish">三方登录</ddbutton>使用需要谨慎!!! -->
      <ddbutton class="add_but" @click="openDetails">+发布新版本</ddbutton>
    </div>
    <detail ref="new_detail" @father_fun="get_list"></detail>
    <div class="context" :style="{ height: pub_height - 110 + 'px' }">
      <div class="title">担当办公APP</div>
      <div class="history" :style="{ height: pub_height - 160 + 'px' }">
        <el-collapse>
          <el-collapse-item v-for="item in activities" :key="item.versionName">
            <template slot="title">
              <span>
                <span class="circle"></span>
                <span style="margin-right:30px" v-show="item.createTime != ''"
                  >日期：{{ item.createTime | formateTitle }}</span
                >
                <span v-show="item.createTime == ''" style="margin-right:30px"
                  >日期：1970-00-00</span
                >
                <span v-if="item.client == 1">
                  veresionName：IOS
                  <span>{{ item.versionName + "版" }}</span>
                </span>
                <span v-if="item.client == 2">
                  veresionName：Android
                  <span>{{ item.versionName + "版" }}</span>
                </span>
                <span v-if="item.client == 3">
                  veresionName：Windows
                  <span>{{ item.versionName + "版" }}</span>
                </span>
                <span v-if="item.client == 4">
                  veresionName：Mac(Intel处理器)
                  <span>{{ item.versionName + "版" }}</span>
                </span>
                <span v-if="item.client == 5">
                  veresionName：Win7
                  <span>{{ item.versionName + "版" }}</span>
                </span>
                <span v-if="item.client == 6">
                  veresionName：Mac(Apple芯片/M系列)
                  <span>{{ item.versionName + "版" }}</span>
                </span>

                <span style="margin-left:30px;">
                  versionCode：
                  <span>{{ item.versionCode }}</span>
                </span>
              </span>
            </template>
            <div
              class="ele_con"
              flexContainer
              style="justify-content:space-between"
            >
              <div class="color_666">描述:</div>
              <div
                class="color_999"
                style="text-align:left"
                v-if="!item.isEditing"
              >
                {{ item.desc }}
              </div>
              <!-- 暂时隐藏编辑输入框 -->
              <!-- <div class="edit_input" v-if="item.isEditing" style="flex: 1; margin-right: 20px;">
                <el-input 
                  v-model="item.editDesc" 
                  type="textarea" 
                  :rows="3"
                  placeholder="请输入描述信息">
                </el-input>
              </div> -->

              <div class="delete_btu" v-if="!item.isEditing">
                <!-- 暂时隐藏编辑按钮，保留删除按钮 -->
                <!-- <el-button @click="edit_fun(item)">编辑</el-button> -->
                <el-button @click="delete_fun(item)">删除</el-button>
              </div>

              <!-- 暂时隐藏编辑确认取消按钮 -->
              <!-- <div class="edit_btu" v-if="item.isEditing">
                <el-button @click="confirm_edit(item)" type="primary">确定</el-button>
                <el-button @click="cancel_edit(item)">取消</el-button>
              </div> -->
            </div>
            <div class="ele_con" flexContainer>
              <div class="color_666">URL:</div>
              <div class="color_999" flex_1>{{ item.downUrl }}</div>
            </div>
            <div class="ele_con" flexContainer>
              <div class="color_new">
                三方登录: {{ item.auditing == 0 ? "开启" : "未开启" }}
              </div>
              <div class="color_new">
                是否强制更新: {{ item.isMust == 1 ? "是" : "否" }}
              </div>
              <div class="color_new">
                是否需要审核:
                <span v-if="item.auditing == 1">已审核</span>
                <el-button v-else style="padding:5px" @click="auditiong(item)"
                  >通过</el-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  get_publish,
  update_publish,
  delete_publish,
  setAuditiong,
} from "@/api/publish";
export default {
  components: {
    ddbutton: () =>
      import(/* webpackChunkName: "design" */ "@/components/button"),
    detail: () =>
      import(/* webpackChunkName: "design" */ "./components/new_publish"),
  },
  data() {
    return {
      reverse: true,
      activities: [],
    };
  },
  mounted() {
    this.get_list();
  },
  methods: {
    edit_fun(item) {
      // 开启编辑模式，保存原始描述
      this.$set(item, "isEditing", true);
      this.$set(item, "editDesc", item.desc);
    },
    confirm_edit(item) {
      // 准备更新数据，包含所有必需字段
      let data = {
        auditing: item.auditing,
        client: item.client,
        createTime: item.createTime,
        desc: item.editDesc,
        downUrl: item.downUrl,
        forceMinVersionCode: item.forceMinVersionCode || 0,
        isMust: item.isMust,
        versionName: item.versionName,
      };

      update_publish(data)
        .then((res) => {
          if (res.code == 1) {
            // 更新成功，退出编辑模式，更新列表
            item.desc = item.editDesc;
            item.isEditing = false;
            this.get_list();
            this.$message({
              message: "描述修改成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg || "修改失败",
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: error.msg || "修改失败",
            type: "error",
          });
        });
    },
    cancel_edit(item) {
      // 取消编辑，恢复原状态
      item.isEditing = false;
      item.editDesc = item.desc;
    },
    delete_fun(item) {
      this.$confirm("是否删除此版本，删除后无法恢复?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          let data = {
            auditing: 0,
            client: item.client,
            createTime: 0,
            desc: "",
            downUrl: "",
            isMust: 0,
            versionName: item.versionName,
          };
          delete_publish(data)
            .then((res) => {
              this.get_list();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            })
            .catch((error) => {
              this.$message({
                message: "删除失败",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    auditiong(item) {
      console.log(item);
      this.$confirm("请确认是否通过审核", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = {
          auditing: "1",
          client: item.client,
          versionName: item.versionName,
        };
        setAuditiong(data).then((res) => {
          this.get_list();
          if (res.code == 1) {
            this.$message({
              message: "修改审核状态成功",
              type: "success",
            });
          }
        });
      });
    },
    update_publish() {
      if (this.popular_auditing == 0) {
        this.popular_auditing = 1;
      } else {
        this.popular_auditing = 0;
      }
      let data = {
        auditing: this.popular_auditing, //三方登录是否开启 0未开启 1已开启
        client: "", //1.ios 2.安卓
        createTime: "", //不用传
        desc: "", //描述
        downUrl: "", //url
        isMust: "", //是否必须 1是 2否
        versionName: "", //版本号
      };
      update_publish(data)
        .then((res) => {
          this.get_list();
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "info",
            });
          }
        })
        .catch((error) => {
          this.$message({
            message: error.msg,
          });
        });
    },
    //获取版本列表
    get_list() {
      get_publish()
        .then((res) => {
          console.log("123", res);
          // console.log("成功调用父组件方法");
          this.activities = res.data;
          this.popular_auditing = this.activities[0].auditing;
        })
        .catch((error) => {});
    },
    load() {
      //打算做版本列表分页但是现在没有  v-infinite-scroll="load"
    },
    openDetails() {
      this.$refs.new_detail.init();
    },
  },
  computed: mapState(["pub_height"]),
};
</script>
<style lang="scss" scoped>
.whole {
  background-color: $menu-color;
  flex-direction: column;

  .button {
    padding-top: 14px;
    padding-right: 22px;

    .add_but {
      width: 120px;
      margin-left: 20px;
      @include s-c-w(14, $menu-color, 400);
    }
  }

  .context {
    margin-top: 18px;
    padding: 0px 53px;

    .title {
      @include s-c-w(17, $detail_t, 400);
      text-align: center;
      padding-bottom: 28px;
      border-bottom: 1px solid $border;
    }

    .history {
      overflow: scroll;
      margin-top: 18px;

      .delete_btu {
        margin-left: 40px;

        /deep/.el-button {
          border: none;
          padding: 5px 10px;
          background-color: $tab;
          @include s-c-w(12, $menu-color, 500);
        }
      }

      .edit_btu {
        margin-left: 40px;

        /deep/.el-button {
          border: none;
          padding: 5px 10px;
          background-color: $tab;
          @include s-c-w(12, $menu-color, 500);
          margin-right: 5px;
        }

        /deep/.el-button--primary {
          background-color: #409eff;
        }
      }

      .circle {
        width: 12px;
        height: 12px;
        border-radius: 25px;
        display: inline-block;
        margin-right: 10px;
        background-color: $menu-child;
      }

      /deep/.el-collapse {
        border: none;

        .el-collapse-item__header {
          height: 30px;
          line-height: 30px;
          border: none;
          display: block;
          @include s-c-w(16, $menu-child, 500);
        }

        .el-collapse-item__wrap {
          border: none;
          border-left: 1px solid #d3d3d3;
          padding: 8px 10px;
          margin: 0px 5px;
        }

        .el-collapse-item__content {
          padding-bottom: 0px;
        }

        .el-collapse-item__arrow {
          margin-left: 10px;
        }
      }

      .ele_title {
        @include s-c-w(14, $text-one, 500);
      }

      .ele_con {
        margin-top: 10px;

        .color_new {
          width: auto;
          margin-right: 60px;
          @include s-c-w(14, $text-other, 500);
        }

        .color_666 {
          width: 80px;
          flex-shrink: 0;
          @include s-c-w(14, $text-other, 500);
        }

        .color_999 {
          @include s-c-w(14, $text-other, 500);
          flex: 1;
        }
      }
    }
  }
}
</style>
